import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let ctx = {};
let queue = [];
let timer = null;
let lastPauseTs = null;

export const telSetCtx = (c) => { ctx = { ...ctx, ...c }; };

const profId = () => {
  try { return JSON.parse(sessionStorage.getItem('activeProfile') || 'null')?.id || ''; } catch { return ''; }
};

export const telFlush = () => {
  if (!queue.length || !ctx.content_id) return;
  const events = queue.splice(0, 50);
  const payload = { ...ctx, profile_id: profId(), events };
  try {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    if (!navigator.sendBeacon || !navigator.sendBeacon(`${API}/telemetry/player`, blob)) {
      axios.post(`${API}/telemetry/player`, payload, { withCredentials: true }).catch(() => {});
    }
  } catch { /* ignore */ }
};

export const tel = (type, at, meta = {}) => {
  if (type === 'pause') lastPauseTs = Date.now();
  if (type === 'play' && lastPauseTs) {
    meta.paused_s = Math.round((Date.now() - lastPauseTs) / 1000);
    lastPauseTs = null;
  }
  queue.push({ type, at: Math.round(at || 0), meta, ts: new Date().toISOString() });
  if (!timer) timer = setInterval(telFlush, 8000);
  if (queue.length >= 25) telFlush();
};

if (typeof window !== 'undefined') window.addEventListener('pagehide', telFlush);
